@use "../../styles/breakpoint.module.scss" as *;

.wrapper {
    border-bottom: 1px solid var(--light-gray);
    margin: 0 0 var(--spacer-48) 0;
    padding: 0 0 var(--spacer-8) 0;

    @media ($below-mobile) {
        align-items: center;
        display: flex;
        flex-direction: column;
    }
}

.label {
    composes: fontCaption from "../../styles/composable/typography.module.css";
    color: var(--gray);
}

.copy {
    composes: fontBody20 from "../../styles/composable/typography.module.css";
    color: var(--dark-brown);
    margin: 0 0 var(--spacer-24) 0;
}

.contentWrapper {
    padding: 0 var(--spacer-48) var(--spacer-48) var(--spacer-48);

    @media ($below-mobile) {
        // Overriding Flexihero values to match design requirements
        flex-direction: column !important;
    }

    & ~ div {
        // Overriding default alignment values of Split component
        // to match design requirements
        align-self: flex-start !important;
    }
}

.image {
    & img {
        max-height: 90px;
        max-width: 396px;
    }
}

.socialIcon {
    fill: var(--black);
    margin-right: var(--spacer-16);

    svg {
        width: var(--spacer-24);
        height: var(--spacer-24);
    }
}
